module.exports = "/images/toolbox.svg";